import React from 'react'

import { ReactComponent as Graphic } from '../../gfx/goldencircle.svg'

const GoldenCircleGraphic = class extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const circleEls = [
      document.querySelector('svg [class*=circle-why]'),
      document.querySelector('svg [class*=circle-what]'),
      document.querySelector('svg [class*=circle-how]'),
    ]

    let index = 0

    circleEls[index].classList.add('is-active')

    this.animationInterval = setInterval(() => {
      index = index + 1
      if (index >= circleEls.length) index = 0
      circleEls.forEach(item => item.classList.remove('is-active'))
      circleEls[index].classList.add('is-active')
    }, 4000)
  }

  componentWillUnmount() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval)
      this.animationInterval = null
    }
  }

  render() {
    return (
      <div className="text-center c-golden-circle-graphic">
        <Graphic />
      </div>
    )
  }
}

export default GoldenCircleGraphic
